export const ID = 'e0991a03-6ba4-4f51-add7-588dde7c0ae6';

export const NAME = 'Coupon';
